import React, { useState, useEffect } from 'react';
import { Linkedin, Github, Twitter } from 'lucide-react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleNewsletter = (e) => {
    e.preventDefault();
    // Integrate with Mailchimp or EmailJS here
    alert('Inscrito na newsletter com sucesso!');
    setEmail('');
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-12" data-aos="fade-up">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-xl font-bold mb-4 text-green-400">Newsletter</h3>
            <p className="mb-4 text-gray-300">Receba as últimas novidades sobre nossas soluções Unisales.</p>
            <form onSubmit={handleNewsletter} className="flex bg-gray-800 rounded-lg overflow-hidden">
              <input
                type="email"
                placeholder="Seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 p-3 bg-gray-700 text-white placeholder-gray-400 border-none focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 font-semibold transition duration-300">
                Inscrever
              </button>
            </form>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-xl font-bold mb-4 text-green-400">Redes Sociais</h3>
            <div className="flex space-x-6">
              <a href="https://linkedin.com/company/olimars" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition duration-300">
                <Linkedin className="w-7 h-7" />
              </a>
              <a href="https://github.com/olimars" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition duration-300">
                <Github className="w-7 h-7" />
              </a>
              {/* <a href="https://twitter.com/olimars" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition duration-300">
                <Twitter className="w-7 h-7" />
              </a> */}
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="300">
            <h3 className="text-xl font-bold mb-4 text-green-400">Contacto</h3>
            <p className="text-gray-300 mb-2">Email: comercial@olimars.com</p>
            <p className="text-gray-300">Telefone: +351 910373618(Chamada para a rede móvel nacional)</p>
          </div>
        </div>
        <div className="text-center border-t border-green-500/30 pt-6">
          <p className="text-gray-400">&copy; 2025 Olimars. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
